<template>
  <div class="conf-editor-container">
    <el-form ref="form" label-position="top" :model="form">
      <el-form-item>
        <el-select v-model="id">
          <el-option
            v-for="key in confKeys"
            :key="key.value"
            :label="key.label"
            :value="key.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <template v-for="field in fields">
        <template v-if="field.type === 'SELECT'">
          <el-form-item :label="field.label" :key="field.prop" :prop="field.prop" :rules="field.rule">
            <el-select
              v-model="form[field.prop]"
              @change="emitChange"
            >
              <el-option
                v-for="option in field.options"
                :key="option.label"
                :label="option.label"
                :value="option.value"
                >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-else-if="field.type === 'NUMBER'">
          <el-form-item :label="field.label" :key="field.prop" :prop="field.prop" :rules="field.rule">
            <el-input-number
              v-model="form[field.prop]"
              controls-position="right"
              :step="1"
              :step-strictly="true"
              :min="field.min"
              :max="field.max"
              @change="emitChange"
            >
            </el-input-number> {{ field.unit }}
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item :label="field.label" :key="field.prop" :prop="field.prop" :rules="field.rule">
            <el-input
              v-model="form[field.prop]"
              @change="emitChange"
            >
            </el-input>
          </el-form-item>
        </template>

      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'config',
    event: 'change',
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.setForm();
  },
  data() {
    const id = this.config.id || Object.keys(this.schema)[0];

    return {
      id,
      form: {
        id,
      },
    };
  },
  computed: {
    // 配置类型
    confKeys() {
      const keys = Object.keys(this.schema);
      return keys.map(k => ({
        label: this.$t(`components.confInput.ids.${k}`),
        value: k,
      }));
    },
    // 可选配置域
    fields() {
      if (this.schema[this.id]) {
        return [...this.schema[this.id]];
      }
      return [];
    },
  },
  watch: {
    id() {
      this.setForm();
      this.emitChange();
    },
    config(newVal) {
      if (newVal && newVal.id) {
        this.id = newVal.id;
      }
      this.setForm();
    },
  },
  methods: {
    setForm() {
      // 上次配置值
      const configValue = { ...this.config };
      // 重置 form
      this.form = {
        id: this.id,
      };

      for (let i = 0; i < this.fields.length; i += 1) {
        const { prop } = this.fields[i];
        this.$set(this.form, prop, configValue[prop]);
      }
    },
    emitChange() {
      this.$emit('change', { ...this.form });
    },
    // 表单验证吗，供父组件调用
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.conf-editor-container {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>

